import React from "react";
import { Button, Dropdown, Icon, Menu, Tag, Tooltip } from "antd";
import { withNamespaces } from "react-i18next";

import classes from "./DocumentsEditor.css";

class TableColsFilter extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      tableFilterColsVisible: false,
    };
  }

  render() {
    return (
      <Dropdown
        overlay={
          <Menu style={{ padding: "5px" }}>
            {this.props.columns.map((item, i) => (
              <div style={{ marginBottom: "3px" }} key={item.key}>
                <button
                  key={item.title}
                  type="button"
                  style={{
                    border: "none",
                    padding: "0",
                    background: "none",
                    width: "100%",
                  }}
                >
                  <Tag
                    className={classes.tag}
                    color={
                      this.props.documentManagementTableExcludedCols[item.key]
                        ? undefined
                        : "#108ee9"
                    }
                    onClick={() => {
                      if (this.props.columns.length - 1 !== i) {
                        this.props.documentManagementTableColsUpdate({
                          ...this.props.documentManagementTableExcludedCols,
                          [item.key]: !this.props
                            .documentManagementTableExcludedCols[item.key],
                        });
                      }
                    }}
                  >
                    {item.title}
                    {this.props.columns.length - 1 !== i &&
                      (this.props.documentManagementTableExcludedCols[
                        item.key
                      ] ? (
                        <Icon type="plus" />
                      ) : (
                        <Icon type="close" />
                      ))}
                  </Tag>
                </button>
              </div>
            ))}
          </Menu>
        }
        trigger={["click"]}
        visible={this.state.tableFilterColsVisible}
        onVisibleChange={(flag) => {
          this.setState({ tableFilterColsVisible: flag });
        }}
      >
        <Tooltip placement="topLeft" title={this.props.i18n.t("NamespaceDocumentsEditor:Table columns view")}>
          <Button style={{ position: "relative" }}>
            <Icon
              type="filter"
              style={{
                fontSize: "14px",
                color: "#333",
                margin: "-2px 1px 0 0",
              }}
            />
            {Object.keys(this.props.documentManagementTableExcludedCols).some(
              (key) => !!this.props.documentManagementTableExcludedCols[key]
            ) && <div className={classes.dot} />}
          </Button>
        </Tooltip>
      </Dropdown>
    );
  }
}

export default withNamespaces()(TableColsFilter);



// WEBPACK FOOTER //
// ./src/containers/DocumentsEditor/TableColsFilter.js